import type { PocTableRowCustomEvent } from 'commons/types';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { useNavigate } from 'react-router-dom';
import { useEapSettingsListContext } from './use-eap-settings-list-context.hook';

export interface UseEapSettingsListReturn {
    configurations: EapSettings[];
    isLoading: boolean;
    selectedRows: EapSettings[];
    handleOnSelectRows: (configurationId: string, event: PocTableRowCustomEvent<boolean>) => void;
    handleOnClickRow: (eapSettingId: string) => void;
    selectSpecificRows: (rows: EapSettings[]) => void;
    clearSelectedRows: VoidFunction;
    refreshList: VoidFunction;
    onDeleted: VoidFunction;
}

export const useEapSettingsList = (): UseEapSettingsListReturn => {
    const { configurations, isLoading, selectedRows, refreshList, setSelectedRows } = useEapSettingsListContext();
    const navigate = useNavigate();

    const handleOnSelectRows = (configurationId: string, event: PocTableRowCustomEvent<boolean>) => {
        const configuration = configurations.find((conf) => conf.id === configurationId);
        setSelectedRows((prevSelectedRows) =>
            event.detail
                ? [...prevSelectedRows, configuration!]
                : prevSelectedRows.filter((conf) => conf.id !== configurationId)
        );
    };

    const handleOnClickRow = (eapSettingId: string) => {
        navigate(eapSettingId);
    };

    const selectSpecificRows = (rows: EapSettings[]) => {
        setSelectedRows(rows);
    };

    const clearSelectedRows = () => {
        setSelectedRows([]);
    };

    const onDeleted = () => {
        clearSelectedRows();
        refreshList();
    };

    return {
        configurations,
        isLoading,
        selectedRows,
        handleOnSelectRows,
        handleOnClickRow,
        selectSpecificRows,
        clearSelectedRows,
        refreshList,
        onDeleted,
    };
};
